// display and required properties are set to false by default for all fields
export const defaultFields = {
  title: {
    name: 'title',
    value: '',
    rules: {
      title: 'Title/Salutation',
      required: { required: false }
    },
    display: false
  },
  firstname: {
    name: 'firstname',
    value: '',
    rules: {
      title: 'First name',
      required: { required: false }
    },
    display: false
  },
  lastname: {
    name: 'lastname',
    value: '',
    rules: {
      title: 'Last name',
      required: { required: false }
    },
    display: false
  },
  email: {
    name: 'email',
    value: '',
    rules: {
      title: 'Email',
      required: { required: false },
      email: true
    },
    display: false
  },
  phone: {
    name: 'phone',
    value: '',
    rules: {
      title: 'Phone',
      ignoreNull: true,
      required: { required: false },
      phone: true
    },
    display: false
  },
  extn: {
    name: 'extn',
    value: '',
    rules: {
      title: 'Extn.',
      ignoreNull: true,
      required: { required: false },
      numeric: true
    },
    display: false
  },
  conference: {
    name: 'conference',
    value: '',
    rules: {
      title: 'Conference',
      required: { required: false },
      ignoreNull: true
    },
    display: false
  },
  userType: {
    name: 'userType',
    value: '',
    rules: {
      title: 'Requester Type',
      required: { required: false }
    },
    display: false
  },
  medicalSpeciality: {
    name: 'medicalSpeciality',
    value: '',
    rules: {
      title: 'Medical Speciality',
      required: { required: false }
    },
    display: false
  },
  affiliation: {
    name: 'affiliation',
    value: '',
    rules: {
      title: 'Affiliation/Institution',
      required: { required: false }
    },
    display: false
  },
  hcpLicenseNumber: {
    name: 'hcpLicenseNumber',
    value: '',
    rules: {
      title: 'HCP License Number',
      ignoreNull: true,
      required: { required: false }
    },
    display: false
  },
  street: {
    name: 'street',
    value: '',
    rules: {
      title: 'Street Address',
      required: { required: false }
    },
    display: false
  },
  city: {
    name: 'city',
    value: '',
    rules: {
      title: 'City/Town',
      required: { required: false }
    },
    display: false
  },
  state: {
    name: 'state',
    value: '',
    rules: {
      title: 'State/Province',
      required: { required: false }
    },
    display: false
  },
  postalCode: {
    name: 'postalCode',
    value: '',
    rules: {
      title: 'ZIP/Postal code',
      required: { required: false }
    },
    display: false
  },
  country: {
    name: 'country',
    value: '',
    rules: {
      title: 'Country',
      required: { required: false }
    },
    display: false
  },
  selectedOption: {
    name: 'selectedOption',
    value: '',
    rules: {
      title: 'selectedOption',
      required: { required: false }
    },
    display: false
  },
  agree: {
    name: 'consent',
    value: false,
    rules: {
      title: 'consent',
      required: {
        required: { required: false },
        message: ''
      }
    },
    display: false
  },
  product: {
    name: 'product',
    value: '',
    rules: {
      title: 'Product',
      required: { required: false }
    },
    display: false
  },
  deliveryMethod: {
    name: 'deliveryMethod',
    value: '',
    rules: {
      title: 'Delivery Method',
      required: { required: false }
    },
    display: false,
    disabled: false
  },
  responseDeadline: {
    name: 'responseDeadline',
    value: '',
    displayValue: '',
    rules: {
      title: 'Response Deadline',
      required: { required: false }
    },
    display: false
  },
  question: {
    name: 'question',
    value: '',
    rules: {
      title: 'Medical Question',
      required: { required: false }
    },
    display: false
  },
  followup: {
    name: 'followup',
    value: true,
    rules: {
      title: 'Follow-up Required',
      required: { required: false }
    },
    display: false
  },
  indicator: {
    name: 'Topic',
    value: '',
    rules: {
      title: 'Topic',
      ignoreNull: true,
      required: { required: false }
    },
    display: false
  },
  respondedWith: {
    name: 'respondedWith',
    value: '',
    rules: {
      title: 'Responded With',
      required: { required: false }
    },
    display: false
  }
}

export const fieldConfiguration = {
  SCIBOOTH: [
    {
      name: 'title',
      required: true,
      display: true
    },
    {
      name: 'firstname',
      required: true,
      display: true
    },
    {
      name: 'lastname',
      required: true,
      display: true
    },
    {
      name: 'email',
      required: true,
      display: true
    },
    {
      name: 'phone',
      required: false,
      display: true
    },
    {
      name: 'extn',
      required: false,
      display: true
    },
    {
      name: 'userType',
      required: true,
      display: true
    },
    {
      name: 'medicalSpeciality',
      required: true,
      display: true
    },
    {
      name: 'affiliation',
      required: false,
      display: true
    },
    {
      name: 'hcpLicenseNumber',
      required: false,
      display: false
    },
    {
      name: 'street',
      required: false,
      display: true
    },
    {
      name: 'city',
      required: false,
      display: true
    },
    {
      name: 'state',
      required: false,
      display: true
    },
    {
      name: 'postalCode',
      required: false,
      display: true
    },
    {
      name: 'country',
      required: true,
      display: true
    },
    {
      name: 'product',
      required: true,
      display: true
    },
    {
      name: 'deliveryMethod',
      required: true,
      display: true,
      disabled: false,
      placeholder: 'None'
    },
    {
      name: 'responseDeadline',
      required: false,
      display: false
    },
    {
      name: 'conference',
      required: true,
      display: true
    },
    {
      name: 'indicator',
      required: false,
      display: false
    },
    {
      name: 'question',
      required: true,
      display: true
    },
    {
      name: 'agree',
      required: false,
      display: false
    },
    {
      name: 'followup',
      required: false,
      display: true
    },
    {
      name: 'respondedWith',
      required: false,
      display: true
    }
  ],
  CONFERENCE: [
    {
      name: 'title',
      required: true,
      display: true
    },
    {
      name: 'firstname',
      required: true,
      display: true
    },
    {
      name: 'lastname',
      required: true,
      display: true
    },
    {
      name: 'email',
      required: true,
      display: true
    },
    {
      name: 'phone',
      required: false,
      display: true
    },
    {
      name: 'extn',
      required: false,
      display: true
    },
    {
      name: 'userType',
      required: true,
      display: true
    },
    {
      name: 'medicalSpeciality',
      required: true,
      display: true
    },
    {
      name: 'affiliation',
      required: false,
      display: true
    },
    {
      name: 'hcpLicenseNumber',
      required: false,
      display: false
    },
    {
      name: 'street',
      required: false,
      display: true
    },
    {
      name: 'city',
      required: false,
      display: true
    },
    {
      name: 'state',
      required: false,
      display: true
    },
    {
      name: 'postalCode',
      required: false,
      display: true
    },
    {
      name: 'country',
      required: true,
      display: true
    },
    {
      name: 'product',
      required: true,
      display: true
    },
    {
      name: 'deliveryMethod',
      required: true,
      display: true
    },
    {
      name: 'responseDeadline',
      required: true,
      display: true
    },
    {
      name: 'conference',
      required: true,
      display: true
    },
    {
      name: 'indicator',
      required: false,
      display: false
    },
    {
      name: 'question',
      required: true,
      display: true
    },
    {
      name: 'agree',
      required: false,
      display: false
    },
    {
      name: 'followup',
      required: false,
      display: false
    },
    {
      name: 'respondedWith',
      required: false,
      display: false
    }
  ],
  MI_PORTAL_REQUEST: [
    {
      name: 'title',
      required: true,
      display: true
    },
    {
      name: 'firstname',
      required: true,
      display: true
    },
    {
      name: 'lastname',
      required: true,
      display: true
    },
    {
      name: 'email',
      required: true,
      display: true
    },
    {
      name: 'phone',
      required: false,
      display: true
    },
    {
      name: 'extn',
      required: false,
      display: true
    },
    {
      name: 'userType',
      required: true,
      display: true
    },
    {
      name: 'medicalSpeciality',
      required: true,
      display: true
    },
    {
      name: 'affiliation',
      required: false,
      display: true
    },
    {
      name: 'hcpLicenseNumber',
      required: false,
      display: false
    },
    {
      name: 'street',
      required: false,
      display: true
    },
    {
      name: 'city',
      required: false,
      display: true
    },
    {
      name: 'state',
      required: false,
      display: true
    },
    {
      name: 'postalCode',
      required: false,
      display: true
    },
    {
      name: 'country',
      required: true,
      display: true
    },
    {
      name: 'product',
      required: true,
      display: true
    },
    {
      name: 'deliveryMethod',
      required: true,
      display: true
    },
    {
      name: 'responseDeadline',
      required: true,
      display: true
    },
    {
      name: 'conference',
      required: false,
      display: false
    },
    {
      name: 'indicator',
      required: false,
      display: true
    },
    {
      name: 'question',
      required: true,
      display: true
    },
    {
      name: 'agree',
      required: {
        required: false,
        message: ''
      },
      display: true
    },
    {
      name: 'followup',
      required: false,
      display: false
    },
    {
      name: 'respondedWith',
      required: false,
      display: false
    }
  ]
}



// WEBPACK FOOTER //
// ./src/mi-app/submitInquiry/FlowTypeFieldConfiguration.js